import type { JSX } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Button } from '@artosera/ui';
import { listerJournal } from '../lib/api.js';
import { formaterDate } from '../lib/format.js';
import pageStyles from '../styles/page.module.css';
import { DetailJournal } from './DetailJournal.js';
import { TableauDefilant } from './TableauDefilant.js';
import tableStyles from '../styles/table.module.css';

export function AuditTable({ galerie }: { galerie?: string }): JSX.Element {
  const { t } = useTranslation('console');
  const [page, setPage] = useState(1);
  const requete = useQuery({
    queryKey: ['console', 'journal', galerie ?? null, page],
    queryFn: () => listerJournal(galerie, page),
  });

  const entrees = requete.data ?? [];

  if (requete.isLoading) return <p className={pageStyles.videEtat}>{t('commun.chargement')}</p>;
  if (entrees.length === 0 && page === 1) {
    return <p className={pageStyles.videEtat}>{t('journal.vide')}</p>;
  }

  return (
    <div>
      <TableauDefilant>
        <table className={tableStyles.table}>
          <thead>
            <tr>
              <th scope="col">{t('journal.colonnes.date')}</th>
              <th scope="col">{t('journal.colonnes.acteur')}</th>
              <th scope="col">{t('journal.colonnes.action')}</th>
              <th scope="col">{t('journal.colonnes.cible')}</th>
              <th scope="col">{t('journal.colonnes.details')}</th>
            </tr>
          </thead>
          <tbody>
            {entrees.map((entree, index) => (
              <tr key={`${entree.date}-${index}`}>
                <td>{formaterDate(entree.date, '—')}</td>
                <td>{entree.acteur}</td>
                <td className={tableStyles.cellulePrincipale}>
                  {t(`journal.actions.${entree.action}`, { defaultValue: entree.action })}
                </td>
                <td>{entree.cible}</td>
                <td className={tableStyles.celluleMuette}>
                  <DetailJournal entree={entree} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableauDefilant>
      <div className={tableStyles.pagination}>
        <Button
          variant="secondary"
          size="sm"
          disabled={page === 1}
          onClick={() => setPage((p) => Math.max(1, p - 1))}
        >
          {t('journal.pagePrecedente')}
        </Button>
        <span>{t('journal.page', { page })}</span>
        <Button
          variant="secondary"
          size="sm"
          disabled={entrees.length === 0}
          onClick={() => setPage((p) => p + 1)}
        >
          {t('journal.pageSuivante')}
        </Button>
      </div>
    </div>
  );
}
